module.exports = __webpack_public_path__ + "img/success_6.c4c7a811.gif";